import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { getDashboard, getRevenueChart } from '@/services/dashboard.api';

export function useDashboard(siteId: string | null) {
  const qc = useQueryClient();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const query = useQuery({
    queryKey: ['dashboard', siteId],
    queryFn: () => getDashboard(siteId!),
    enabled: !!siteId,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 60 * 1000,
  });

  const manualRefresh = useCallback(async () => {
    if (!siteId) return;
    setIsRefreshing(true);
    try {
      // Force backend cache clear + refetch through React Query
      await qc.fetchQuery({
        queryKey: ['dashboard', siteId],
        queryFn: () => getDashboard(siteId, true),
        staleTime: 0,
      });
    } finally {
      setIsRefreshing(false);
    }
  }, [siteId, qc]);

  return { ...query, manualRefresh, isRefreshing };
}

export function useRevenueChart(siteId: string | null, days = 7) {
  return useQuery({
    queryKey: ['revenue-chart', siteId, days],
    queryFn: () => getRevenueChart(siteId!, days),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000,
  });
}
